// extracted by mini-css-extract-plugin
export var tab = "styles-module--tab--98b97";
export var tabHeading = "styles-module--tabHeading--ea542";
export var toggle = "styles-module--toggle--320c0";